/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 9
// module chunks = 1 2